import type { Category } from '@scayle/storefront-nuxt'
import type { UseRpcOptions } from '@scayle/storefront-nuxt/composables'

export default ({
  key = 'useRootCategories',
  params,
  options,
}: {
  key?: string
  params?: any
  options?: UseRpcOptions<'getRootCategories'>
} = {}) => {
  const { data, status, refresh } = useRpc(
    'getRootCategories',
    key,
    {
      ...params,
      with: {
        ...params?.with,
      },
      properties: {
        ...params?.properties,
        withName: ['sale'],
      },
    },
    options,
  )

  const getCategory = (categoryId: number): Category | undefined => {
    const find = (id: number, arr: Category[]): Category | undefined => {
      for (const i of arr) {
        if (i.id === id) return i
        if (i.children?.length) {
          const result = find(id, i.children)
          if (result) return result
        }
      }
    }
    return find(categoryId, data.value?.categories || [])
  }

  const getParentCategory = (categoryId: number): Category | undefined => {
    const parentId = getCategory(categoryId)?.parentId
    return parentId ? getCategory(parentId) : undefined
  }

  return {
    data,
    refresh,
    status,
    getCategory,
    getParentCategory,
  }
}
